import french from './fr';
import english from './en';
import spanish from './es';

export default Object.freeze({ ...french, ...english, ...spanish });
